// @flow

import {DataTableRowSize, TableSize} from '../constants';
import type {TreeRowData, RowData} from '../typedef';

type CreateRowsMapType = {|
    rowsHeight: Array<number>,
    rowsOffset: Array<number>,
    tableHeight: number,
|};

export const createRowsMap = <DataRow>(
    rows: $ReadOnlyArray<RowData<DataRow> | TreeRowData<DataRow>>,
    defaultRowHeight: number = DataTableRowSize[TableSize.DEFAULT]
): CreateRowsMapType => {

    return rows.reduce((acc, cur, index) => {
        const rowHeight = Number(cur.rowHeight ?? defaultRowHeight);
        const topOffset =
            typeof acc.rowsOffset[index - 1] === 'number' &&
            typeof acc.rowsHeight[index - 1] === 'number'
                ? acc.rowsOffset[index - 1] + acc.rowsHeight[index - 1]
                : 0;

        return {
            rowsHeight: [...acc.rowsHeight, rowHeight],
            rowsOffset: [...acc.rowsOffset, topOffset],
            tableHeight: acc.tableHeight + rowHeight
        };
    }, {rowsHeight: [], rowsOffset: [], tableHeight: 0});
};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../typedef");
